import { defineNuxtPlugin } from '#app'
import VueMultiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'
import '@/assets/css/vendor/custom-vue-multiselect.css'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('VueMultiselect', VueMultiselect)
})
